import { render, staticRenderFns } from "./user-activity-counts.vue?vue&type=template&id=f3676fe2&lang=pug"
import script from "./user-activity-counts.vue?vue&type=script&lang=js"
export * from "./user-activity-counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports